import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from 'academy-common-lib/utils/DataFetchingClient';
import { BASE_SERVICE_URI } from '../../constants/ApiConstants';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { produce } from 'immer';
import { useCallback, useEffect, useMemo } from 'react';
import Raven from 'raven-js';
export const UPWORK_URI = `${BASE_SERVICE_URI}/progress/v1/upwork`;
export const LEGACY_UPWORK_LOCAL_STORAGE_KEY = 'academy:dashboard:upwork';
export const useSentToUpwork = create()(persist(set => ({
  sentToUpwork: [],
  addToSentToUpwork(trackId) {
    set(state => produce(state, draft => {
      draft.sentToUpwork.push(trackId);
    }));
  }
}), {
  name: 'academy:upwork'
}));
const SEND_TO_UPWORK = registerMutation({
  fieldName: 'sendToUpwork',
  args: ['trackId'],
  fetcher({
    trackId
  }) {
    return http.post(`${UPWORK_URI}/send/${trackId}`);
  }
});
export const useSendToUpwork = ({
  trackId
}) => {
  const {
    sentToUpwork,
    addToSentToUpwork
  } = useSentToUpwork();
  const [mutate, {
    loading: sendToUpworkLoading,
    error: sendToUpworkError
  }] = useMutation(SEND_TO_UPWORK, {
    variables: {
      trackId
    },
    onError: error => {
      Raven.captureException(error);
    },
    onCompleted: () => {
      addToSentToUpwork(trackId);
    }
  });
  const sendToUpwork = useCallback(async () => {
    await mutate();
  }, [mutate]);
  const sentToUpworkAlready = useMemo(() => sentToUpwork.includes(trackId), [sentToUpwork, trackId]);
  useEffect(() => {
    /**
     * 20240112: This to migrate the old localStorage key to the new one.
     * This can be removed after a while.
     */
    try {
      const existingValuesString = localStorage.getItem(LEGACY_UPWORK_LOCAL_STORAGE_KEY);
      if (existingValuesString) {
        const existingValues = JSON.parse(existingValuesString);
        if (Array.isArray(existingValues) && existingValues.length > 0) {
          for (const value of existingValues) {
            addToSentToUpwork(Number(value));
          }
        }
        localStorage.removeItem(LEGACY_UPWORK_LOCAL_STORAGE_KEY);
      }
    } catch (e) {
      console.error(e);
      Raven.captureException(e);
    }
  }, [addToSentToUpwork]);
  return {
    sendToUpwork,
    sendToUpworkLoading,
    sendToUpworkError,
    sentToUpworkAlready
  };
};